import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LS_KEY = "df_reminder";

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function getStoredReminder() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY));
  } catch {
    return null;
  }
}

async function getRegistration() {
  return navigator.serviceWorker.register("/sw.js");
}

export async function enableReminder(time) {
  if (!pushSupported()) throw new Error("Push not supported on this browser");

  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications blocked");

  const reg = await getRegistration();
  await navigator.serviceWorker.ready;

  const { data } = await axios.get(`${API}/vapid-public-key`);
  const appServerKey = urlBase64ToUint8Array(data.publicKey);

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: appServerKey,
    });
  }

  const tz_offset = new Date().getTimezoneOffset();
  await axios.post(`${API}/reminders/subscribe`, {
    subscription: sub.toJSON(),
    time,
    tz_offset,
  });

  const stored = { time, endpoint: sub.endpoint };
  localStorage.setItem(LS_KEY, JSON.stringify(stored));
  return stored;
}

export async function disableReminder() {
  const stored = getStoredReminder();
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg && (await reg.pushManager.getSubscription());
    if (sub) {
      await axios.post(`${API}/reminders/unsubscribe`, { endpoint: sub.endpoint });
      await sub.unsubscribe();
    } else if (stored?.endpoint) {
      await axios.post(`${API}/reminders/unsubscribe`, { endpoint: stored.endpoint });
    }
  } catch (e) {
    /* ignore */
  }
  localStorage.removeItem(LS_KEY);
}

export async function sendTestReminder() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (!sub) throw new Error("No active subscription");
  await axios.post(`${API}/reminders/test`, { endpoint: sub.endpoint });
}
